import axios from 'axios';

export function checkToken(token) {
  return axios.get(`/user?token=${token}`);
}

export function setPassword(params) {
  return axios.post('/user', params);
}

export function doLogin(params) {
  return axios.post('/user/login', params);
}

export function doLogout() {
  return axios.delete('/user/login');
}

export function requestResetPassword(params) {
  return axios.post('/user/request_reset_password', params);
}

export function resetPassword(params) {
  return axios.post('/user/reset_password', params);
}

export function exportSurveyResult(params) {
  return axios.get('/export_survey_result', { responseType: 'blob', params: params });
}

export function exportHealthCheckupInstitution(params) {
  return axios.get('/export_health_checkup_institution', { responseType: 'blob', params: params });
}

export function exportRegularHealthCheckupResult(params) {
  return axios.get('/export_regular_health_checkup_result', { responseType: 'blob', params: params });
}
